module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.supportmeasures-04dd4f9478a372c2252a50a686a7e2eb.svg";